export default __webpack_public_path__ + "static/media/rae-background.67159508.jpg";